import { RefObject, useRef } from "react";
import { VideoPlayer } from "expo-video";
import { ICarouselInstance } from "react-native-reanimated-carousel/src/types";
import { OnboardingDataResponse } from "@src/types/onboardingDataResponse";
import { Platform } from "react-native";

export const useOnSnapped = (
  carrouselRef: RefObject<ICarouselInstance | null>,
  videoPlayers: RefObject<(VideoPlayer | null)[]>,
  setActiveNavigationIndex: (index: number) => void
) => {
  const timeoutRef = useRef<any>(null);

  const clearCurrentTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const onSnapped = async (
    index: number,
    carouselInterval: number,
    onboardingDataState: OnboardingDataResponse[]
  ) => {
    clearCurrentTimeout();
    setActiveNavigationIndex(index);

    if (Platform.OS !== "web") {
      for (let i = 0; i < onboardingDataState.length; i++) {
        if (i !== index) {
          const player = videoPlayers.current[i];
          if (player) {
            player.currentTime = 0;
            player.pause();
          }
        }
      }

      const currentPlayer = videoPlayers.current[index];
      if (currentPlayer) {
        currentPlayer.play();
      }
    }
    if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        carrouselRef.current?.next();
      }, carouselInterval);
    }
  };

  return { onSnapped, clearCurrentTimeout };
};
